import Vue from 'vue';
import Router from 'vue-router';

import { createRoutes as createProfileRoutes } from '../pages/profile';
import { createRoutes as createPfDodRoutes } from '../pages/pf-dod';
import Auth from "../pages/auth/Auth";
import Register from "../pages/auth/Register";

Vue.use(Router);

const DefaultLayout = () => import('../pages/default' /* webpackChunkName: "DefaultLayout" */);

const NewDefaultLayout = () => import("../uikit/components/AppDefaultLayout/AppDefaultLayout.vue")

const NewErrorPage = () => import("../uikit/components/AppDefaultLayout/specialContents/404/404.vue")

const NewStartPage = () => import("../uikit/components/AppDefaultLayout/specialContents/startPage/StartPage.vue")

// Разделение кода на уровне роутинга (страниц) с ленивой загрузкой
const ActivityPage = () =>
  import('../pages/activities/card' /* webpackChunkName: "ActivityPage" */);
const ActivityInfoTab = () =>
  import(
    '../pages/activities/card/info' /* webpackChunkName: "ActivityInfoTab" */
  );
const ActivityPressTab = () =>
  import(
    '../pages/activities/card/press' /* webpackChunkName: "ActivityPressTab" */
  );
const ActivityResultTab = () =>
  import(
    '../pages/activities/card/result' /* webpackChunkName: "ActivityResultTab" */
  );
const ActivitiesCalendar = () =>
  import(
    '../pages/activities/calendar' /* webpackChunkName: "ActivitiesCalendar" */
  );
const ActivitiesDay = () =>
  import('../pages/activities/day' /* webpackChunkName: "ActivitiesDay" */);
const ActivitesOrder = () =>
  import(
    '../pages/activities/card/order' /* webpackChunkName: "ActivitesOrder" */
  );

const BlogArticlePage = () =>
  import('../pages/blog/article' /* webpackChunkName: "BlogArticlePage" */);
const BlogArticlesPage = () =>
  import('../pages/blog/list' /* webpackChunkName: "BlogArticlesPage" */);
const EmailVerifyPage = () =>
  import('../pages/verify/email' /* webpackChunkName: "EmailVerifyPage" */);
const ErrorPage = () =>
  import('../pages/404.vue' /* webpackChunkName: "ErrorPage" */);
const EventCardPage = () =>
  import('../pages/event/card/' /* webpackChunkName: "EventCardPage" */);
const EventListPage = () =>
  import('../pages/event/list/' /* webpackChunkName: "EventListPage" */);
const EventMapPage = () =>
  import('../pages/event/map/' /* webpackChunkName: "EventMapPage" */);
const HomePage = () =>
  import('../pages/home/' /* webpackChunkName: "HomePage" */);

// const NewHomePage = () =>
//     import('../pages/start-page/StartPage.vue' /* webpackChunkName: "HomePage" */);
// const NewDefaultLayout = () => import()

const ModuleListPage = () =>
  import('../pages/modules/list' /* webpackChunkName: "ModuleListPage" */);

const InvitePage = () =>
  import('../pages/invite' /* webpackChunkName: "InvitePage" */);

const ModulePage = () =>
  import('../pages/modules/card' /* webpackChunkName: "ModulePage" */);

const ProfessionsListPage = () =>
  import(
    '../pages/professions/list' /* webpackChunkName: "ProfessionsListPage" */
  );

const ProfessionCardPage = () =>
  import(
    '../pages/professions/card' /* webpackChunkName: "ProfessionCardPage" */
  );

const OrganizationPage = () =>
  import(
    '../pages/organizations/card' /* webpackChunkName: "OrganizationPage" */
  );
const OrganizationSpace = () => import('../pages/organizations/organization-space/OrganizationSpace.vue'  /* webpackChunkName: "OrganizationSpacePage" */)
const OrganizationInfoTab = () =>
  import(
    '../pages/organizations/card/info' /* webpackChunkName: "OrganizationPage" */
  );
const OrganizationMapTab = () =>
  import(
    '../pages/organizations/card/map' /* webpackChunkName: "OrganizationPage" */
  );
const OrganizationPhotosTab = () =>
  import(
    '../pages/organizations/card/photos' /* webpackChunkName: "OrganizationPage" */
  );
const OrganizationReviewsTab = () =>
  import(
    '../pages/organizations/card/reviews' /* webpackChunkName: "OrganizationPage" */
  );

const Space = () => import('../pages/organizations/card/spaces/Spaces.vue'  /* webpackChunkName: "Space" */)

const OrganizationsPage = () =>
  import(
    '../pages/organizations/list' /* webpackChunkName: "OrganizationsPage" */
  );
const OrganizationsMap = () =>
  import(
    '../pages/organizations/map' /* webpackChunkName: "OrganizationsMap" */
  );

const Competences = () =>
  import('../pages/competences/list' /* webpackChunkName: "Competences" */);

const CompetenceCard = () =>
  import('../pages/competences/card' /* webpackChunkName: "CompetenceCard" */);

const GlobalSearchList = () =>
  import('../pages/global-search' /* webpackChunkName: "GlobalSearchList" */);

const SmartInfoPage = () =>
  import('../pages/smart/info' /* webpackChunkName: "SmartInfoPage" */);
const NokoInfoPage = () =>
  import('../pages/noko/info' /* webpackChunkName: "NokoInfoPage" */);
const TicketPage = () =>
  import('../pages/ticket' /* webpackChunkName: "TicketPage" */);
const PrivacyPolicy = () =>
  import('../pages/privacy-policy/' /* webpackChunkName: "PrivacyPolicy" */);
const TermsPage = () =>
  import('../pages/terms/' /* webpackChunkName: "TermsPage" */);
const CertPage = () =>
  import('../pages/cert/' /* webpackChunkName: "TermsPage" */);
const InquiryPage = () =>
  import('../pages/inquiry' /* webpackChunkName: "InquiryPage" */);

const ProfessionInfoTab = () =>
  import(
    '../pages/professions/card/info' /* webpackChunkName: "ProfessionInfoTab" */
  );
const ProgramTab = () =>
  import(
    '../pages/professions/card/program' /* webpackChunkName: "ProgramTab" */
  );
const CompetenceTab = () =>
  import(
    '../pages/professions/card/competence' /* webpackChunkName: "CompetenceTab" */
  );

const VacanciesPage = () =>
  import('../pages/vacancies/list' /* webpackChunkName: "VacanciesPage" */);
const VacancyPage = () =>
  import('../pages/vacancies/card' /* webpackChunkName: "VacanciePage" */);

const NewProgramPage = () =>
  import('../pages/newprogram' /* webpackChunkName: "NewProgramPage" */);

const organizationRoutes = [
  'organization',
  'organization-map',
  'organization-photos',
  'organization-reviews',
];

const activityRoutes = [
  'activity',
  'activity-map',
  'activity-photos',
  'activity-reviews',
  'activity-press',
  'activity-result',
  'activity-order',
];

const activitiesRoutes = [
  ...activityRoutes,
  'activities',
  'activities-calendar',
];

const modulesRoutes = ['modules', 'module'];

const createRouter = (providers, store) => {
  const listProps = (route) =>
    Object.assign({}, route.query, {
      section: route.params.section,
      subsection: route.params.subsection,
    });

  const redirectTo404 = (module) => {
    const beforeEnter = async (to, from, next) => {
      const {
        state: { apiModules },
        getters,
      } = store;

      const isModuleStateEmpty = apiModules.length === 0;

      let result = null;

      if (isModuleStateEmpty) {
        result = await store.dispatch('getApiModules');
      }

      if (result || !isModuleStateEmpty) {
        getters[module] ? next() : next({ path: '404' });
      }
    };
    return beforeEnter;
  };

  const router = new Router({
    mode: 'history',

    scrollBehavior: (to, from, savedPosition) => {
      if (to.name === from.name && from.name === 'profile-children') return;

      const noScroll = (list) => {
        if (
          to.name === from.name &&
          to.params.id &&
          to.params.id !== from.params.id
        )
          return false;
        return list.indexOf(to.name) !== -1 && list.indexOf(from.name) !== -1;
      };
      if (noScroll(organizationRoutes) || noScroll(activityRoutes)) return;

      if (savedPosition) return savedPosition;
      if (to.hash) return { selector: to.hash };

      return { x: 0, y: 0 };
    },

    routes: [
      {
        path: '/',
        redirect: {name: 'start-page'}
      },
      {
        path: '/old',
        component: DefaultLayout,
        meta: { hideProgress: true },
        //name: 'old-layout',
        children: [

          {
            path: '/',
            component: HomePage,
            name: 'home',
          },

          ...createProfileRoutes({
            path: '/profile',
            name: 'profile',
            redirectTo404,
          }),
          {
            path: "/auth",
            name: "auth",
            meta: { isAuth: false },
            component: Auth,
            props: (route) => {
              return {
                redirect: route.query.redirect,
              };
            },
          },
          {
            path: "/auth/register",
            name: "auth-register",
            meta: { isAuth: false },
            component: Register,
            props: (route) => {
              return {
                redirect: route.query.redirect,
              };
            },
          },

          ...createPfDodRoutes({
            path: '/pfdod',
            name: 'pfdod',
            redirectTo404,
          }),

          {
            path: '/blog',
            component: BlogArticlesPage,
            name: 'blog',
          },



          {
            path: '/verify/email',
            component: EmailVerifyPage,
            name: 'verify',
          },

          {
            path: '/blog/:id',
            component: BlogArticlePage,
            name: 'blog-article',
            props: (route) => {
              return {
                id: route.params.id,
                code: route.params.code,
              };
            },
          },

          {
            path: '/directivities/:section?/:subsection?',
            component: EventListPage,
            name: 'events',
            props: listProps,
          },

          {
            path: '/modules/:section?/:subsection?',
            component: ModuleListPage,
            name: 'modules',
            props: listProps,
          },

          {
            path: '/module/:id',
            component: ModulePage,
            name: 'module',
            props: listProps,
          },

          {
            path: '/professions',
            component: ProfessionsListPage,
            name: 'professions',
            props: listProps,
          },

          {
            path: '/profession/:id',
            name: 'profession',
            component: ProfessionCardPage,
            props: listProps,
          },

          {
            path: '/competences',
            component: Competences,
            name: 'competences',
            props: listProps,
          },

          {
            path: '/competence/:id',
            name: 'competence',
            component: CompetenceCard,
            props: listProps,
          },

          {
            path: '/on-map/:section?/:subsection?',
            component: EventMapPage,
            name: 'map',
            props: listProps,
          },

          {
            path: '/archive',
            component: ErrorPage, //EventArchivePage
            name: 'event-archive',
          },

          // {
          //   path: '/invite/register',
          //   component: InvitePage,
          //   name: 'invite',
          //   beforeEnter: (to, from, next) => {
          //     next(!to.query.code ? { path: '404' } : true);
          //   },
          // },

          {
            path: '/program/:id-:code?:groupid?',
            component: EventCardPage,
            name: 'event-card',
            props: (route) => {
              return {
                id: route.params.id,
                code: route.params.code,
                groupid: route.params.groupid,
              };
            },
          },

          {
            path: '/program/:id',
            component: EventCardPage,
          },

          {
            path: '/review',
            component: ErrorPage,
            name: 'reviews',
            children: [
              {
                path: ':id',
                component: ErrorPage,
                name: 'review-card',
              },
            ],
          },

          {
            path: '/organization-space/:partnerId/:id',
            component: OrganizationSpace,
            name: 'organization-spaces',
          },

          {
            path: '/organization/:id', // -:code
            component: OrganizationPage,
            children: [
              {
                path: '',
                name: 'organization',
                component: OrganizationInfoTab,
                beforeEnter: redirectTo404('hasApiModuleOrganizations'),
              },
              {
                path: 'space',
                name: 'space',
                component: Space,
                beforeEnter: redirectTo404('hasApiModuleOrganizations'),
              },
              {
                path: 'on-map',
                component: OrganizationMapTab,
                name: 'organization-map',
                beforeEnter: redirectTo404('hasApiModuleOrganizations'),
              },
              {
                path: 'photos',
                component: OrganizationPhotosTab,
                name: 'organization-photos',
                beforeEnter: redirectTo404('hasApiModuleOrganizations'),
              },
              {
                path: 'reviews',
                component: OrganizationReviewsTab,
                name: 'organization-reviews',
                beforeEnter: redirectTo404('hasApiModuleOrganizations'),
              },
            ],
          },

          {
            path: '/organizations-map',
            component: OrganizationsMap,
            name: 'organizationsmap',
            beforeEnter: redirectTo404('hasApiModuleOrganizations'),
          },

          {
            path: '/organizations',
            component: OrganizationsPage,
            name: 'organizations',
            beforeEnter: redirectTo404('hasApiModuleOrganizations'),
          },

          {
            path: '/vacancies',
            component: VacanciesPage,
            name: 'vacancies',
            beforeEnter: redirectTo404('hasApiModuleVacancies'),
            props: listProps,
          },

          {
            path: '/vacancy/:id',
            component: VacancyPage,
            name: 'vacancy',
            beforeEnter: redirectTo404('hasApiModuleVacancies'),
          },

          {
            path: '/activity/:id', // -:code
            component: ActivityPage,
            children: [
              {
                path: 'order',
                components: { order: ActivitesOrder },
                name: 'activity-order',
                meta: { isOrder: true, isAuth: true },
              },
              {
                path: '',
                name: 'activity',
                component: ActivityInfoTab,
              },
              {
                path: 'press',
                component: ActivityPressTab,
                name: 'activity-press',
              },
              {
                path: 'result',
                component: ActivityResultTab,
                name: 'activity-result',
              },
            ],
          },

          {
            path: '/activities-calendar/:section?/:subsection?',
            component: ActivitiesCalendar,
            name: 'activities-calendar',
          },

          {
            path: '/activities/:section?/:subsection?',
            component: ActivitiesDay,
            name: 'activities',
            props: listProps,
          },

          {
            path: '/term',
            component: TermsPage,
            name: 'terms',
          },

          {
            path: '/smart',
            component: SmartInfoPage,
            name: 'smart-info',
          },

          {
            path: '/noko',
            component: NokoInfoPage,
            name: 'noko-info',
          },

          {
            path: '/ticket',
            component: TicketPage,
            name: 'ticket-info',
          },

          {
            path: '/term_pfdod',
            component: CertPage,
            name: 'term-pfdod',
            beforeEnter: redirectTo404('hasApiModulePfdod'),
          },

          {
            path: '/inquiry',
            component: InquiryPage,
            name: 'inquiry',
            meta: { isAuth: true },
          },

          {
            path: '/privacy-policy',
            component: PrivacyPolicy,
            name: 'privacy-policy',
          },

          {
            path: '/contacts',
            component: ErrorPage, //ContactsPage,
            name: 'contacts',
          },

          {
            path: '/new-program/:id?',
            component: NewProgramPage,
            name: 'new-program',
            meta: { isAuth: true },
          },

          {
            path: '/search',
            component: GlobalSearchList,
            name: 'search',
          },

          {
            path: '*',
            component: ErrorPage,
            name: 'error-404',
          },
        ],
      },
      {
        path: '/new',
        component: NewDefaultLayout,
       // name: 'new-layout',
        children: [
          {
            path: '/',
            component: NewStartPage,
            name: 'start-page',
          },
          {
            path: 'blog',
            component: BlogArticlesPage,
            name: 'blog2',
          },
          {
            path: '*',
            component: NewErrorPage,
            name: 'new-error-404',
          },
        ]
      }
    ],
  });

  router.beforeEach((to, from, next) => {
    const isAuthRoute = to.matched.some(({ meta }) => meta.isAuth === true);
    const isAuthRouteFalse = to.matched.some(({ meta }) => meta.isAuth === false);
    if (isAuthRoute) {
      !providers.$auth.authLabelFromCookie
          ? next({ path: '/'})
          : next();
    } else if (isAuthRouteFalse) {
      providers.$auth.authLabelFromCookie
          ? next({ path: '/'})
          : next();
    } else {
      next();
    }
  });

  return router;
};

export {
  activityRoutes,
  activitiesRoutes,
  modulesRoutes,
  createRouter,
  organizationRoutes,
};



// WEBPACK FOOTER //
// ./src/router/index.js